var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"headline"},[_vm._t("header")],2),(_vm.$slots.header)?_c('v-divider'):_vm._e(),_vm._t("navigation"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }